module.exports = __webpack_public_path__ + "TJ.png?b2303ccff37abde7319533081e215ee1";